<template>
  <div class="drawer">
    <h3 class="drawer__title">Vamos preencher os dados no guichê</h3>
    <p class="drawer__text drawer__line">
      Pelo check-in só é aceito os conselhos CRM e CRO. Vamos adiantar outros dados de atendimento.
    </p>

    <VButton text="Continuar" @click.native="$emit('go-to-next-page')" />
    <VButton
      style="margin-top: 8px"
      variant="secondary"
      text="Voltar"
      @click.native="$emit('toggle-drawer')"
    />
  </div>
</template>

<script>
import { dataLayersMixin } from '@/utils/mixins';

export default {
  mixins: [dataLayersMixin],
  created() {
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Finalize seu atendimento no guichê (modal)',
    });
  },
};
</script>
